module.exports = __webpack_public_path__ + "static/media/ec.c9a41882.svg";